import { Box, Stack } from '@mui/material';

import HeaderNew from '../header/HeaderNew';
import { IPageProps } from '../LayoutPreference/layoutTypes';

/** @deprecated Temporary dual-layout rollout new page shell. Remove when legacy layout is retired. */
const PageWithHeaderNew = ({
  children,
  tabs,
  title,
}: IPageProps & { children: React.ReactNode }): React.ReactElement => {
  return (
    <Stack sx={{ display: 'flex', minHeight: '100dvh' }}>
      <Box
        sx={{
          position: 'sticky',
          top: 0,
          bgcolor: 'background.paper',
          zIndex: (theme) => theme.zIndex.appBar,
        }}
      >
        <HeaderNew title={title} tabs={tabs} />
      </Box>
      <Box
        sx={{
          display: 'flex',
          flex: 1,
          flexDirection: 'column',
          minHeight: 0,
          p: 3,
        }}
      >
        {children}
      </Box>
    </Stack>
  );
};

export default PageWithHeaderNew;
